import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  AlertsServiceVariables_create,
  AlertsServiceVariables_update,
  AlertsServiceVariables_delete,
  AlertsServiceVariables_readById,
  AlertsServiceVariables_readAll,
  AlertsServiceVariables_ReadAllByServiceId
} from 'src/app/GlobalVariables';

import {
  AlertsServiceVariablesCreateRequestDTO,
  AlertsServiceVariablesUpdateRequestDTO,
  AlertsServiceVariablesDeleteRequestDTO,
  AlertsServiceVariablesReadByIdRequestDTO,
  AlertsServiceVariablesDTO,
  AlertsServiceVariablesList,
  AlertsServiceVariablesReadAllByServiceIdRequestDTO
} from './alertServiceVariable.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertsServiceVariablesService {
  constructor(private http: HttpClient) {}

  AlertsServiceVariables_create(data: AlertsServiceVariablesCreateRequestDTO): Observable<AlertsServiceVariablesDTO> {
    return this.http.post<AlertsServiceVariablesDTO>(AlertsServiceVariables_create, data);
  }

  AlertsServiceVariables_update(data: AlertsServiceVariablesUpdateRequestDTO): Observable<AlertsServiceVariablesDTO> {
    return this.http.post<AlertsServiceVariablesDTO>(AlertsServiceVariables_update, data);
  }

  AlertsServiceVariables_delete(data: AlertsServiceVariablesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(AlertsServiceVariables_delete, data);
  }

  AlertsServiceVariables_readById(data: AlertsServiceVariablesReadByIdRequestDTO): Observable<AlertsServiceVariablesDTO> {
    return this.http.post<AlertsServiceVariablesDTO>(AlertsServiceVariables_readById, data);
  }

  AlertsServiceVariables_readAll(): Observable<AlertsServiceVariablesList> {
    return this.http.get<AlertsServiceVariablesList>(AlertsServiceVariables_readAll);
  }

  AlertsServiceVariables_ReadAllByServiceId(data: AlertsServiceVariablesReadAllByServiceIdRequestDTO): Observable<AlertsServiceVariablesList> {
    return this.http.post<AlertsServiceVariablesList>(AlertsServiceVariables_ReadAllByServiceId, data);
  }

}
